module.exports = __webpack_public_path__ + "static/media/search-icon.f60b1c03.svg";